import Css from "./style.module.scss";

import { Portal } from "nlib/ui";
import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";

const MARGIN = 8;

const STYLES = {
  default: "",
  warning: "#f5a623",
  negative: "#e24e45",
  positive: "#12ab6b"
};

const POSITIONS = {
  left: Css.left,
  right: Css.right
};

const GlobalTooltip = () => {
  const [text, setText] = useState(null);

  const [style, setStyle] = useState({});

  const [className, setClassName] = useState(undefined);

  const timeoutRef = useRef(null);

  const handleWindowEnter = useCallback((event) => {
    setText(null);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (event.target.dataset?.tooltip) {
      const rect = event.target.getBoundingClientRect();

      const animationDuration = event.target.dataset.tooltipDelay;

      timeoutRef.current = setTimeout(() => {
        setText(event.target.dataset.tooltip);
        setStyle({
          color: STYLES[event.target.dataset.tooltipStyle] || STYLES.default,
          ...({
            top: {
              top: rect.top - MARGIN,
              left: rect.left + (rect.width >> 1)
            },
            left: {
              top: rect.top + (rect.height >> 1),
              left: rect.left - MARGIN
            },
            right: {
              top: rect.top + (rect.height >> 1),
              left: rect.right + MARGIN
            }
          }[event.target.dataset.tooltipPosition || "top"])
        });
        setClassName(POSITIONS[event.target.dataset.tooltipPosition] || POSITIONS.default);
      }, +animationDuration || 0);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("mouseover", handleWindowEnter);
    window.addEventListener("click", handleWindowEnter);

    return () => {
      window.removeEventListener("mouseover", handleWindowEnter);
      window.removeEventListener("click", handleWindowEnter);
    };
  }, [handleWindowEnter]);
  if (!text) return null;

  return (
    <Portal>
      <div className={classNames(Css.tooltip, className)} style={style}>
        <span>{text}</span>
      </div>
    </Portal>
  );
};

export default React.memo(GlobalTooltip);
